import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface IListUserRequest extends IBaseRequest {
    limit?: number;
    offset?: number;
    orderBy?: string;
    countOnly?: boolean;
    accessFilter?: string;
    groupId?: number;
    notPublic?: boolean;
    onlyActive?: boolean;
    public?: boolean;
    roleId?: number;
    treeHandle?: number;
    userName?: string;
}

export class ListUserRequest extends BaseRequest implements IListUserRequest {
    public limit?: number;
    public offset?: number;
    public orderBy?: string;
    public countOnly?: boolean;
    public accessFilter?: string;
    public groupId?: number;
    public notPublic?: boolean;
    public onlyActive?: boolean;
    public public?: boolean;
    public roleId?: number;
    public treeHandle?: number;
    public userName?: string;

    constructor( _server: string, 
        _session: string, 
        _onlyActive?: boolean, 
        _limit?: number, 
        _offset?: number, 
        _orderBy?: string, 
        _countOnly?: boolean, 
        _accessFilter?: string, 
        _groupId?: number, 
        _notPublic?: boolean, 
        _public?: boolean, 
        _roleId?: number, 
        _treeHandle?: number, 
        _userName?: string
        ) {
        super(_server, _session);
        this.limit = _limit;
        this.offset = _offset;
        this.orderBy = _orderBy;
        this.countOnly = _countOnly;
        this.accessFilter = _accessFilter;
        this.groupId = _groupId;
        this.notPublic = _notPublic;
        this.onlyActive = _onlyActive;
        this.public = _public;
        this.roleId = _roleId;
        this.treeHandle = _treeHandle;
        this.userName = _userName;
    }

    toXml(): string {
        var parameters:string = super.toXml();
        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.orderBy, 'orderBy');
        parameters += this.makeNode(this.countOnly, 'countOnly');
        parameters += this.makeNode(this.accessFilter, 'accessFilter');
        parameters += this.makeNode(this.groupId, 'groupId');
        parameters += this.makeNode(this.notPublic, 'notPublic');
        parameters += this.makeNode(this.onlyActive, 'onlyActive');
        parameters += this.makeNode(this.public, 'public');
        parameters += this.makeNode(this.roleId, 'roleId');
        parameters += this.makeNode(this.treeHandle, 'treeHandle');
        parameters += this.makeNode(this.userName, 'userName');

        return super.wrapperXml("ListUser", parameters);
    }
}